// extracted by mini-css-extract-plugin
export default {"wrapper":"EOS2s2RW","dragging":"EQ9Kq5Zu","pill":"aUCtXV9K","squeezeA":"TIDDTIsJ","squeezeB":"XcCUwo0z","pillSqueeze":"oWEqOZWa"};